/**
 * Karaoke / teleprompter trainee lines, keyed by `script_id`.
 *
 * These are what the teleprompter types into the input box (key `1` advances to
 * the next one). They are the legitimate origin of the trainee's typed text —
 * the server quotes back the *actual* `user_message` text in the debrief, so
 * there is no drift between what's on screen and what's scored.
 *
 * Order must match the scripted turn bundles in
 * `app/domains/counterpoint/scripts/demo_golden_path.rb` (turns 0–4).
 */
export const KARAOKE_LINES: Record<string, string[]> = {
  demo_golden_path: [
    "It's probably nothing, I'm just a bit tired.",
    "I haven't wanted to do anything for weeks. I stopped going to football.",
    "Does this go to my parents?",
    "Sorry to waste your time — whatever you think is best, you're the expert.",
    "I think… I'd want to talk to someone about it. If that's okay.",
  ],
}
